
import PageTitle from '@/UI/components/common/PageTitle.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Button, Menu, List, Table, Select } from 'ant-design-vue';
import { ProxyDataForm } from '@/UI/components/Helpers/ProxyDataForm';
import { SettingsUsersCosmetologistStore } from '@/store/modules/Settings/UserCosmetologist';
import { UserCosmetologist, FormRules } from '@/form/Settings/userCosmetologist';
import {getStudioId} from '@/UI/lib/state';
import {WorkersStore} from "@/store/modules/Workers";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";

@Component({
    components: {
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-select': Select,
        'a-select-option': Select.Option,
        'a-table': Table,

        PageTitle,
        BaseDataForm,
    },
})
export default class UsersSettings extends mixins(ProxyDataForm) {
    form = new UserCosmetologist();
    private modalAddAccess: boolean = false;

    get staff(): IWorkers | null {
        return WorkersStore.workers;
    }

    addAccess(): void {
        this.modalAddAccess = true;
    }

    selectCosmetologist(id : number): void {
        const worker = this.staff?.data.find(e => e.id === this.form.cosmetologist_id);
        if (worker) this.form.phone = '+' + worker.phone;
    }

    async onSubmit(): Promise<void> {
        if (!(await (this.$refs.StoreForm as any).validate())) return;
        try {
            const response = await SettingsUsersCosmetologistStore.create(this.form);
            if (!response.status) throw new Error(response.response);
            this.$message.success(this.$t("Пользователь успешно добавлен") as string);
            this.modalAddAccess = false;
            this.form = new UserCosmetologist();
        } catch (e) {
            this.$message.error(e.message);
        }
    }

    @Watch('$store.state.salon_id')
    async loadStaff(salonId = getStudioId(this)): Promise<void> {
        this.form = new UserCosmetologist();
        await WorkersStore.fetchAll({limit: 100, filter: {salon_id: Number(salonId)}});
    }

    async created(): Promise<void> {
        await this.loadStaff();
    }
}
